import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddPaiementModal",
  tabindex: "-1",
  role: "dialog",
  ref: "addPaiementModalRef",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "paiement"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = {
  ref: "closePaiementModal",
  class: "btn-close py-0",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-12 col-sm-12 col-xm-12 col-xl-12 col-lg-12"
}
const _hoisted_10 = { class: "upload-container" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "text-center"
}
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  key: 0,
  class: "col-md-12 col-xm-12 col-sm-12 col-xl-12 col-lg-12"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-md-6 col-xm-12 col-sm-12 col-xl-6 col-lg-6" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-md-6 col-xm-12 col-sm-12 col-xl-6 col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-3 col-xm-12 col-sm-12 col-xl-3 col-lg-3 mb-10" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-9 col-xm-12 col-sm-12 col-xl-9 col-lg-9 mb-10" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = {
  class: "btn btn-success",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            ref: "paiementForm",
            onSubmit: _ctx.payer,
            "validation-schema": _ctx.paiementSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.showType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("input", {
                          type: "file",
                          name: "urlImage",
                          ref: "fileInput",
                          onChange: _cache[0] || (_cache[0] = (event) => _ctx.onFilePrinChange(event)),
                          accept: "image/*",
                          hidden: ""
                        }, null, 544),
                        _createElementVNode("div", {
                          class: "preview-card",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                        }, [
                          (_ctx.imagePreview)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.imagePreview,
                                alt: "Image preview"
                              }, null, 8, _hoisted_11))
                            : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[6] || (_cache[6] = [
                                _createElementVNode("div", null, [
                                  _createElementVNode("i", { class: "flaticon-camera fs-1" })
                                ], -1),
                                _createTextVNode(" Cliquez pour ajouter l'image ")
                              ]))),
                          (_ctx.imagePreview)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "delete-btn",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                              }, _cache[7] || (_cache[7] = [
                                _createElementVNode("i", { class: "flaticon-close" }, null, -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.showType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                          _createTextVNode(" Réference "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "referenceDocument",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer la référence du paiement du trésor"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "referenceDocument",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Date paiement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "date_paiement",
                      modelValue: _ctx.date,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event)),
                      type: "date",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer date"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "date_paiement",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                      _createTextVNode(" Montant "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "montant",
                      type: "number",
                      modelValue: _ctx.montant,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.montant) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer montant",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "montant",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Mode "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "mode",
                      modelValue: _ctx.mode,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mode) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          factureholder: "Rechercher un mode",
                          "filter-results": true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          searchable: true,
                          options: _ctx.modeOptions
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "mode",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Facture "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "facture" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps(field, {
                          factureholder: "Rechercher une facture",
                          "filter-results": false,
                          "min-chars": 3,
                          "resolve-on-load": false,
                          delay: 0,
                          searchable: true,
                          "options-limit": 300,
                          options: async (query) => await _ctx.fetchFactures(query),
                          noResultText: "Aucun enregistrement trouvé",
                          noOptionsText: "Tapez au moins trois caractères",
                          onSelect: _ctx.selectionFacture
                        }), null, 16, ["options", "onSelect"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "facture",
                      class: "text-danger"
                    })
                  ])
                ]),
                _withDirectives(_createElementVNode("button", {
                  class: "btn btn-success",
                  type: "submit"
                }, _toDisplayString(_ctx.btntext), 513), [
                  [_vShow, !_ctx.auclic]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_24, _cache[13] || (_cache[13] = [
                  _createElementVNode("span", {
                    class: "spinner-grow spinner-grow-sm",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                ]), 512), [
                  [_vShow, _ctx.auclic]
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}